/**
 *	remove-class.link.js
 */

var removeClassLink = function(scope, elem, attrs) {
	if (attrs.removeClass) {
		elem.removeClass(attrs.removeClass);
	}
};

export default removeClassLink;